<template>
    <v-dialog v-model="dialog" width="600" persistent transition="dialog-bottom-transition" @keydown.esc="close">
        <v-card class="scouting-add-edit-dialog-card">
            <v-toolbar dark color="primary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Comments</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
            </v-toolbar>
            <v-form ref="form">
                <v-container>
                    <v-layout row>
                        <v-flex>                        
                            <v-textarea clearable label="Comments" v-model="comments" />                    
                        </v-flex>
                    </v-layout>
                </v-container>                
                <v-layout wrap class="dialog-action-buttons">
                    <v-flex xs12 sm6>
                        <v-btn block color="error" @click="close">Cancel</v-btn>

                    </v-flex>
                    <v-flex xs12 sm6 >
                        <v-btn block color="success" @click="save">Save</v-btn>
                    </v-flex>
                </v-layout>   
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data() {
        return {
            comments: null
        }
    },
    props: [
        "dialog",
        "notes"
    ],
    components: {
    },
    methods: {
       close() {
           this.$emit("close");
        },
        save() {
            this.$emit('save', this.comments);
        }
    },
    created() {
        if(this.notes) {                
            this.comments = this.notes;
        }
    }
}
</script>
<style>
</style>
